import { render, staticRenderFns } from "./AskForLeave.vue?vue&type=template&id=5879b605&scoped=true&"
import script from "./AskForLeave.vue?vue&type=script&lang=js&"
export * from "./AskForLeave.vue?vue&type=script&lang=js&"
import style0 from "./AskForLeave.vue?vue&type=style&index=0&id=5879b605&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879b605",
  null
  
)

export default component.exports